export default __webpack_public_path__ + "static/media/Scholar.d6f5baea.png";